var config        = require("app/config"),
    get           = require("object-path").get,
    quickMacroize = require("enyo/macroize").quickMacroize;

/**
 * @param   {string}   url      The image url
 * @param   {int}      width    The output image width
 * @param   {int}      height   The output image height
 * @param   {string=}  format   The output image format
 * @param   {int=}     quality  The output image quality
 * @return  {string}   The url to the Thumbor optimized image
 */
module.exports = function(url, width, height, format, quality) {
    var thumborUrl = get(config, "imageOptimizer.thumborUrl", null),
        optimizedImageUrl,
        filters    = [];

    // Thumbor url missing
    if (!thumborUrl) {
        return url;
    }

    // Thumbor base url
    optimizedImageUrl = [thumborUrl];

    // Output size
    optimizedImageUrl.push(quickMacroize("{$width}x{$height}", {
        width:  width,
        height: height
    }));

    // Optional image format filter
    format = format || "";
    format = format.toLowerCase();
    format = ["jpg", "png"].includes(format) ? format : "auto";
    filters.push(quickMacroize(":format({$format})", {
        format: format
    }));

    // Optional quality filter
    if (quality) {
        filters.push(quickMacroize(":quality({$quality})", {
            quality: quality
        }));
    }

    // Apply filters
    if (filters.length) {
        optimizedImageUrl.push("filters" + filters.join(""));
    }

    // Raw image url
    optimizedImageUrl.push(url);

    // Final url
    optimizedImageUrl = optimizedImageUrl.join("/");

    return optimizedImageUrl;
};
